import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {getAppConfig, getAppData, getAppInput} from "../../store/slices/appSlice";
import {getFinancialConfiguration} from "../../store/slices/financialConfigurationsSlice";
import {formatMileage, formatPrice} from "../../helpers/numberFormat";
import {formatDate} from "../../helpers/dateFormat";
import CONST from "../../config/CONST";
import Iframe from "../Iframe/Iframe";
import Loading from "../Loading/Loading";


const FormIframe = (props) => {

    const {
        onIframeHeightChange
    } = props;

    const appConfig = useSelector(getAppConfig);
    const appInput = useSelector(getAppInput);
    const appData = useSelector(getAppData);
    const financialConfiguration = useSelector(getFinancialConfiguration);

    const { t } = useTranslation();

    // const [widgetContainerEl, setWidgetContainerEl] = useState(null);
    const [iframeSrc, setIframeSrc] = useState(null);
    const [isIframeLoaded, setIsIframeLoaded] = useState(false);
    const buildIframeSrc = (appConfig, appInput, financialConfiguration) => {

        const langCode = appConfig.lang.substring(0,2).toUpperCase();
        const baseUrl = CONST.LEAD_FORM_URL[langCode] ? CONST.LEAD_FORM_URL[langCode] : CONST.LEAD_FORM_URL.DEFAULT;
        const queryParameters = {
            language:                   appConfig.lang || "",
            modelName:                  appInput.model || "",
            versionName:                appInput.version || "",
            vehicleTransmission:        appInput.transmissionDescription || "",
            vehicleFuelTypeDescription: appInput.fuelTypeDescription || "",
            nissanVehiclePrice:         typeof(appInput.price) !== 'undefined' ? formatPrice(appData, appInput.price, 2, false) : "",
            vehicleType:                appInput.vehicleType || "",
            MSRP:                       typeof(financialConfiguration.MSRP) !== 'undefined' ? formatPrice(appData, financialConfiguration.MSRP, 2, false) : "",
            MSRPWDiscount:              typeof(financialConfiguration.MSRPWDiscount) !== 'undefined' ? formatPrice(appData, financialConfiguration.MSRPWDiscount, 2, false) : "",
            EIMcode:                    appInput.EIM || "",
            UICcode:                    financialConfiguration.UIC || "",
            customer:                   financialConfiguration.selectedCustomer,
            quoteNumber:                financialConfiguration.quoteNumber || "",
            quoteDate:                  formatDate(Date.now()),
            validityDateFrom:           financialConfiguration.validityDateFrom || "",
            validityDateTo:             financialConfiguration.validityDateTo || "",
            productName:                financialConfiguration.rentalProductName || "",
            productTypeCode:            financialConfiguration.productTypeCode || "",
            duration:                   financialConfiguration.duration ? financialConfiguration.duration + ' ' + t(`FormLayerHeader.Months`): "",
            downpayment:                typeof(financialConfiguration.downpayment) !== 'undefined' ? formatPrice(appData, financialConfiguration.downpayment, 2, false): "",
            mileage:                    typeof(financialConfiguration.mileage) !== 'undefined' ? formatMileage(appData, financialConfiguration.mileage, false, false) + ' ' + t(`FormLayerHeader.Mileage`) : "",
            totalInstallment:           typeof(financialConfiguration.totalInstallment) !== 'undefined' ? formatPrice(appData, financialConfiguration.totalInstallment, 2, false) : "",
            nissanVehiclePriceNoVAT:    typeof(financialConfiguration.nissanVehiclePriceNoVAT) !== 'undefined' ? formatPrice(appData, financialConfiguration.nissanVehiclePriceNoVAT, 2, false) : "",
            BPM:                        typeof(financialConfiguration.BPM) !== 'undefined' ? formatPrice(appData, financialConfiguration.BPM, 2, false) : ""

        }

        const queryString = new URLSearchParams(queryParameters).toString();

        return baseUrl + '?' + queryString + '&nocache=' + new Date().getTime();
    }


    // const findWidgetContainer = () => {
    //     const widgetContainerClassName = "modal";
    //     let el = document.getElementById(CONST.DOM_APP_WIDGET_ID);
    //     let widgetContainerEl;
    //     if(el) {
    //         while (el.parentNode) {
    //             el = el.parentNode;
    //             widgetContainerEl = el.classList && el.classList.length > 0 && el.classList.contains(widgetContainerClassName) ? el : null;
    //             if(widgetContainerEl) {
    //                 break;
    //             }
    //         }
    //     }
    //     return widgetContainerEl;
    // }


    const scrollToTop = () => {
        // if(widgetContainerEl) {
        //     widgetContainerEl.style.scrollBehavior = 'smooth';
        //     widgetContainerEl.scrollTop = 0;
        // }
        const formLayer = document.getElementsByClassName('caabfcl-FormLayer')[0];
        formLayer.style.scrollBehavior = 'smooth';
        formLayer.scrollTop = 0;

        const widgetMainContainer = document.getElementsByClassName('caabfcl-WidgetMainContainer')[0];
        // widgetMainContainer.style.scrollBehavior = 'smooth';
        widgetMainContainer.scrollTop = 0;
    }


    const onIframeURLChange = () => {
        setIsIframeLoaded(true);
        scrollToTop();
    }


    useEffect(() => {
        if(appConfig && appConfig.lang && appInput && appData && financialConfiguration) {
            setIframeSrc(buildIframeSrc(appConfig, appInput, financialConfiguration))
        }
    // eslint-disable-next-line
    }, [appConfig, appInput, appData, financialConfiguration]);

    // useEffect(() => {
    //     setWidgetContainerEl(findWidgetContainer());
    // }, []);

    // useEffect(() => {
    //     if(widgetContainerEl) {
    //         scrollToTop();
    //     }
    // // eslint-disable-next-line
    // }, [widgetContainerEl])

    useEffect(() => {
        scrollToTop();
    }, []);

    if(!iframeSrc) {
        return null;
    }

    if(!appInput || !appConfig || !appData || !financialConfiguration) {
        return null;
    }

    return (
        <>
            <div style={{ display: !isIframeLoaded ? 'block' : 'none' }}>
                <Loading />
            </div>
            <div style={{ visibility: isIframeLoaded ? 'visible' : 'hidden' }}>
                <Iframe
                    src={iframeSrc}
                    onHeightChange={onIframeHeightChange}
                    onLoad={onIframeURLChange}
                />
            </div>
        </>
    )

}

export default FormIframe;